import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/Bolli_Logo.png";
import navIcon1 from "../assets/img/insta.png";
import navIcon2 from "../assets/img/nav-icon2.svg";
import { Link } from "react-router-dom";
import navIcon3 from "../assets/img/Blaumann-Logo.png";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="#"><img src={navIcon1} alt="Icon" /></a>
              <a href="#"><img src={navIcon2} alt="Icon" /></a>
              <a href="#"><img src={navIcon3} alt="Icon" /></a>
            </div>
            <div className="footer-contact">
              <a href="mailto:info@bollinger-energieberatung.de">info@bollinger-energieberatung.de</a><br />
              <a href="tel:+4915782960601">015782960601</a>
              <Link to="/impressum">Impressum</Link>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}